(() => {
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];

  const menuBtn = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (menuBtn && mobileMenu) {
    const closeMenu = () => { mobileMenu.hidden = true; menuBtn.setAttribute('aria-expanded','false'); document.body.classList.remove('menu-open'); };
    menuBtn.addEventListener('click', () => {
      const open = menuBtn.getAttribute('aria-expanded') === 'true';
      if (open) closeMenu(); else { mobileMenu.hidden = false; menuBtn.setAttribute('aria-expanded','true'); document.body.classList.add('menu-open'); }
    });
    $$('a', mobileMenu).forEach(a => a.addEventListener('click', closeMenu));
  }

  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 30);
    onScroll(); window.addEventListener('scroll', onScroll, {passive:true});
  }

  const reveal = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    }), {threshold:.12, rootMargin:'0px 0px -40px 0px'});
    reveal.forEach(el => io.observe(el));
  } else reveal.forEach(el => el.classList.add('is-visible'));

  if (window.matchMedia('(pointer:fine)').matches) {
    $$('.image-frame, .gallery-card, .benefit-card').forEach(card => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
        card.style.setProperty('--rx', `${(-y*3).toFixed(2)}deg`);
        card.style.setProperty('--ry', `${(x*4).toFixed(2)}deg`);
      });
      card.addEventListener('pointerleave', () => { card.style.setProperty('--rx','0deg'); card.style.setProperty('--ry','0deg'); });
    });
  }
})();
